import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ExternalDataService, Customer } from '../../../services/externalDataService.service';

@Component({
  selector: 'app-update-customer-fees',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './update-customer-fees.component.html',
  styleUrl: './update-customer-fees.component.css'
})
export class UpdateCustomerFeesComponent implements OnInit, OnChanges {
  @Input() customer: Customer | null = null;
  @Input() showModal = false;
  @Output() feesUpdated = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();

  feesForm: FormGroup;
  isLoading = false;
  errorMessage = '';

  constructor(
    private fb: FormBuilder,
    private externalDataService: ExternalDataService
  ) {
    this.feesForm = this.fb.group({
      collectionCharge: [null, [Validators.min(0)]],
      platformFeeInPercentage: [null, [Validators.min(0), Validators.max(100)]]
    });
  }

  ngOnInit(): void {
    // Load existing fees when modal opens
    if (this.showModal) {
      this.loadExistingFees();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showModal'] && changes['showModal'].currentValue) {
      this.loadExistingFees();
    }
  }

  onSubmit(): void {
    if (this.feesForm.valid && this.customer) {
      this.isLoading = true;
      this.errorMessage = '';

      const formValue = this.feesForm.value;
      const collectionCharge = formValue.collectionCharge === '' || formValue.collectionCharge === null ? null : formValue.collectionCharge;
      const platformFeeInPercentage = formValue.platformFeeInPercentage === '' || formValue.platformFeeInPercentage === null ? null : formValue.platformFeeInPercentage;

      this.externalDataService.updateCustomerFees(
        this.customer.customerId,
        collectionCharge,
        platformFeeInPercentage
      )
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.feesUpdated.emit();
            this.resetForm();
          },
          error: (error) => {
            this.isLoading = false;
            this.errorMessage = error.error?.message || 'Failed to update customer fees. Please try again.';
          }
        });
    }
  }

  onCancel(): void {
    this.closeModal.emit();
    this.resetForm();
  }

  private loadExistingFees(): void {
    if (this.customer) {
      this.feesForm.patchValue({
        collectionCharge: this.customer.collectionCharge ?? null,
        platformFeeInPercentage: this.customer.platformFeeInPercentage ?? null
      });
    } else {
      this.resetForm();
    }
    this.errorMessage = '';
  }

  private resetForm(): void {
    this.feesForm.reset({
      collectionCharge: null,
      platformFeeInPercentage: null
    });
    this.errorMessage = '';
  }
}

